/** Mirrors `Opportunity.EMPLOYMENT_TYPE_CHOICES` / `WORK_MODE_CHOICES` (api/apps/opportunities/models.py). */

export const EMPLOYMENT_TYPE_LABELS: Record<string, string> = {
  full_time: 'Full time',
  part_time: 'Part time',
  casual: 'Casual',
  contract: 'Contract',
  temporary: 'Temporary',
  internship: 'Internship',
}

export const WORK_MODE_LABELS: Record<string, string> = {
  onsite: 'On-site',
  hybrid: 'Hybrid',
  remote: 'Remote',
}

export const PUBLICATION_STATUS_LABELS: Record<string, string> = {
  draft: 'Draft',
  published: 'Open',
  closed: 'Closed',
  archived: 'Archived',
}

export type PublicationStatusBadge = {
  label: string
  variant: 'defaultSoft' | 'secondarySoft'
}

/** Employer + job-board cards: soft pills; lifecycle actions still use Publish / Unpublish. */
export function getPublicationStatusBadge(
  publicationStatus?: string | null,
): PublicationStatusBadge {
  const published = publicationStatus === 'published'
  const closed = publicationStatus === 'closed'
  const archived = publicationStatus === 'archived'
  return {
    label: published
      ? PUBLICATION_STATUS_LABELS.published
      : closed
        ? PUBLICATION_STATUS_LABELS.closed
        : archived
          ? PUBLICATION_STATUS_LABELS.archived
          : PUBLICATION_STATUS_LABELS.draft,
    variant: published ? 'defaultSoft' : 'secondarySoft',
  }
}
